module.exports = __webpack_public_path__ + "img/10.a7c2cf82.jpg";